import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Space, Table, Tag, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { formatDate, formatRupiah } from '@/lib/format';
import { useAuthStore } from '@/lib/auth-store';
export function ContractsPage() {
    const hasPerm = useAuthStore((s) => s.hasPerm);
    const q = useQuery({
        queryKey: ['makam-contracts'],
        queryFn: async () => (await api.get('/makam/contracts')).data,
    });
    const cols = [
        { title: 'No. Kontrak', dataIndex: 'contract_no', width: 200 },
        { title: 'Petak', width: 140, render: (_, r) => `${r.block_code}·${r.plot_code}` },
        { title: 'Pembeli', dataIndex: 'buyer_name' },
        {
            title: 'Tipe',
            dataIndex: 'contract_type',
            width: 100,
            render: (t) => _jsx(Tag, { color: t === 'SALE' ? 'volcano' : 'orange', children: t }),
        },
        { title: 'Mulai', dataIndex: 'start_date', width: 110, render: (d) => formatDate(d) },
        { title: 'Berakhir', dataIndex: 'end_date', width: 110, render: (d) => d ? formatDate(d) : '—' },
        {
            title: 'Nilai',
            dataIndex: 'total_amount',
            width: 170,
            align: 'right',
            render: (v) => _jsx("span", { className: "money", children: formatRupiah(v) }),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            width: 120,
            render: (s) => (_jsx(Tag, { color: s === 'ACTIVE' ? 'green' : s === 'EXPIRED' ? 'default' : 'red', children: s })),
        },
        {
            title: 'Jurnal',
            dataIndex: 'journal_id',
            width: 120,
            render: (id) => id ? _jsx(Link, { to: `/accounting/journals/${id}`, children: "Lihat" }) : '—',
        },
    ];
    return (_jsxs("div", { children: [_jsxs(Space, { style: { marginBottom: 16, display: 'flex', justifyContent: 'space-between' }, children: [_jsx(Typography.Title, { level: 3, style: { margin: 0 }, children: "Kontrak Makam" }), hasPerm('makam.contract:create') && (_jsx(Link, { to: "/makam/contracts/new", children: _jsx(Button, { type: "primary", icon: _jsx(PlusOutlined, {}), children: "Kontrak Baru" }) }))] }), _jsx(Table, { rowKey: "id", loading: q.isLoading, dataSource: q.data ?? [], columns: cols, pagination: { pageSize: 30 }, size: "middle" })] }));
}
